import { render, staticRenderFns } from "./FileDownloadCard.vue?vue&type=template&id=dfecf9de"
import script from "./FileDownloadCard.vue?vue&type=script&lang=js"
export * from "./FileDownloadCard.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadCard.vue?vue&type=style&index=0&id=dfecf9de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports